import {
    useGetContext,
    useGetCustomerState,
    usePutStateMutation
} from '@api/lendingAPI/lapiHooks';
import { cloneDeep, set } from 'lodash';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useUpdateTurnover = () => {
    const stateKey = useStateKey();
    const { data: state } = useGetCustomerState(stateKey);
    const { data: context } = useGetContext();
    const { mutatePutState: putState, isLoading } =
        usePutStateMutation(stateKey);

    const updateTurnover = async (turnover: number) => {
        if (!state) return;
        const newState = cloneDeep(state);
        set(newState, 'application.company.last_12_months_turnover', {
            amount: parseInt(String(turnover)),
            datetime: new Date().toISOString()
        });
        await putState({ body: { data: newState } });
    };

    const turnoverLastUpdated = Date.parse(
        state?.application?.company?.last_12_months_turnover?.datetime || ''
    );
    const dateJoined = Date.parse(context?.user_date_joined || '');

    const previousTurnover =
        state?.application?.company?.last_12_months_turnover?.amount;

    const shouldUpdateTurnover = hasTurnoverExpired({
        turnoverLastUpdated,
        dateJoined
    });

    return {
        shouldUpdateTurnover,
        previousTurnover,
        updateTurnover,
        isLoading
    };
};

const hasTurnoverExpired = ({
    turnoverLastUpdated,
    dateJoined
}: {
    turnoverLastUpdated: number;
    dateJoined: number;
}) => {
    const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;
    // If your turnover was updated in the last 6 months, don't refresh
    if (turnoverLastUpdated && turnoverLastUpdated > Date.now() - sixMonths) {
        return false;
    }

    // We can't rely on the turnover update datetime (as we historically didnt store it in iwocapay),
    // so if it doesnt exist check if the user signed up in the last 6 months instead
    if (!turnoverLastUpdated && dateJoined > Date.now() - sixMonths) {
        return false;
    }

    // Otherwise ask for a refresh
    return true;
};
